import EditLocation from './EditLocationPage';

export default EditLocation;
